import { gql } from '@apollo/client'

export const CANCEL_INVOICE_MUTATION = gql`
  mutation cancelInvoice($invoiceId: ID!) {
    cancelInvoice(invoiceId: $invoiceId) {
      id
    }
  }
`
